<cmps-dialog>
    <div class="event-header">
        <div class="event-header-title">
            {{ _i18n._7389_CURRENT_COMMITMENTS | translate }}
        </div>
        <div
            class="text"
            *ngIf="!_itemsSelected; else ribbon"
        >
            {{ _i18n._9697_SELECT_A_COMMITMENT | translate }}
        </div>
        <ng-template #ribbon>
            <div class="ribbon">
                <div class="count-selected">
                    <span
                        >{{ _numSelected }}
                        {{ _i18n._9692_COMMITMENTS_SELECTED | translate }}</span
                    >
                </div>
                <button
                    class="associate-btn"
                    (click)="_onAssociateClick()"
                >
                    <cmps-icon svgIcon="sync"></cmps-icon>
                    {{ _i18n._9693_ASSOCIATE | translate }}
                </button>
            </div>
        </ng-template>
    </div>
    <div class="cmps-schedule-event-select-event-dialog--container">
        <div
            class="cmps-schedule-event-select-event-dialog--item"
            [class.disabled]="comm.disabled"
            *ngFor="
                let comm of _data?.availableCommitmentsForUser;
                let i = index
            "
        >
            <div class="current-commitment-item">
                <div class="item-header">
                    <div>
                        <button
                            class="cmps-icon-button--no-bg"
                            cmpsIconButton
                            (click)="_toggleSelect(i)"
                        >
                            <cmps-icon
                                [svgIcon]="
                                    _selected[i]
                                        ? 'radiobox-marked'
                                        : 'checkbox-blank-circle-outline'
                                "
                            ></cmps-icon>
                        </button>
                    </div>
                    <div>
                        <strong class="behaviour-text"
                            >{{ _i18n._9422_BEHAVIOUR_ | translate }}
                            {{ comm.behaviourName }}</strong
                        >
                        <span class="sub-behaviour-text"
                            >{{ _i18n._9423_SUB_BEHAVIOUR_ | translate }}
                            {{ comm.subBehaviourName }}</span
                        >
                    </div>
                </div>
                <div
                    class="goal-list"
                    *ngIf="comm.goals?.length > 0; else nogoal"
                >
                    <div
                        class="goal-item"
                        *ngFor="let goal of comm.goals; let i = index"
                    >
                        <div class="goal-name">
                            {{ _i18n._721_GOAL | translate }} {{ i + 1 }} :
                            {{ goal.metricName }}
                        </div>
                        <div class="goal-info">
                            <span
                                >{{ _i18n._721_GOAL | translate }} ={{
                                    goal.goalValue | number: '1.0-2'
                                }}
                            </span>
                            <span
                                >{{ _i18n._767___TO_GOAL | translate }} ={{
                                    goal.currentPctGoal
                                        | cmpsNumberWithSuffix: '1.0-0'
                                }}
                            </span>
                            <span
                                >{{ _i18n._768___TO_TARGET | translate }} ={{
                                    goal.currentPctTarget
                                        | cmpsNumberWithSuffix: '1.0-0'
                                }}
                            </span>
                        </div>
                    </div>
                </div>
                <ng-template #nogoal>
                    <div class="no-goals">
                        {{ _i18n._9686_NO_GOALS_ | translate }}
                    </div>
                </ng-template>
                <div class="info">
                    <div class="status">
                        {{ _i18n._9420_STATUS_ | translate }}
                        {{ comm.statusName }}
                    </div>
                    <div class="date">
                        {{ _i18n._9683_DATE_CREATED_ | translate }}
                        {{ comm.initialDate | date: 'yyyy-mm-dd' }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</cmps-dialog>
